// Sai krishna 11/17/2022 2700271704 Action dropdown -- Dynamically rendered fields -- Update defined fields section.
// Sai krishna 11/17/2022 2700271704 Action dropdown -- Validation bug fixes.
// Sai Maheshwar 11/20/2022 2700271704 fixed add action bugs and added validations
// Sai Maheshwar 11/21/2022 2700271704 fixed window  and field payload issue
// Sohel 11/22/2022 2700271704 formula Rule Group Table set return Type values
// Rajesh 11/29/2022  2700271704 removed the agency tie
// Ravi 11/30/2022 2700271704 custom window mandatory fields
// Sohel 12/03/2022 2700271704 Triggers Alter Custom window changes
// Sai Maheshwar 12/08/2022 2700271704 Fixed Alter fields on account payload  issue
// akhila 12/21/2022 2700271704 changed labels
// kavyareddy 12/26/2022 2700271704 Fixed label issues
// sai krishna  1/3/2023  2700271704 formula rule changed to data calculatio0ns
// Raghu 02/22/2023 2700271704 added new class to input fields
// phaneendra 03/16/23 2700271704 implemented value textfield based on fieldType
// Prakash 12-04-23 2700271704 fixed ui bug in Trigger Maintenance
// Sohel 04/13/2023 2701334326 Fixed Validation Issue and Added Untie Action
// Prakash 13/04/2023 2700271704 remove margin top
// Prakash 10/05/2023 2700271704 add theming color
// Sohel 05/25/2023 2701334326 Fixed FieldValue Prepopulate issue
// uday 10/23/2023 2701334326 Fixed validation ui bug in tiggers
// Sohel 11/30/2023 2701334326 data calculation field disable css conditionaly modified

import {
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import {Clear, Search} from '@material-ui/icons';
import React, {useContext, useEffect} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchDispositionCodes,
  fetchUserDefinedFields,
  fetchUserDefinedWindows,
  handleSearchRuleGroupFieldData,
} from '../../../../../redux/reducers/EventTactics/EventTactics';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {NumberFormatterPostiveNegavtive} from '../../../../../components/UserDefinedForm/AppTextInputComponents';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const UpdateUserDefined = (props) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {userDefinedWindowData, userDefinedFieldsData} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchDispositionCodes());
    dispatch(fetchUserDefinedWindows());
  }, []);
  const applyToOptions = [
    {key: 'A', value: 'A - Account'},
    {key: 'S', value: 'S - Seed'},
    {key: 'R', value: 'R - Route'},
  ];
  const {
    setShowSearch,
    values,
    setFieldValue,
    touched,
    errors,
    handleChange,
    handleBlur,
    updateWindowRef,
  } = props;
  // const classes = ReusableInputStyles();
  return (
    <>
      <Grid item xs={4} sm={4} className={`form-group ${classes.selectField}`}>
        <FormControl margin="dense" variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-label" required>
            Apply To
          </InputLabel>
          <Select
            fullWidth
            name="applyTo"
            className={` select-gender ${classes.labelName}`}
            required
            value={values?.applyTo || 'none'}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched?.applyTo}
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            // error={Boolean(touched?.applyTo && errors?.applyTo)}
            label={'Select Apply To'}
          >
            <MenuItem value="none" key="none" disabled>
              <span className="defaultSelected"> Select Apply To </span>
            </MenuItem>
            {applyToOptions.map((option) => {
              return (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormHelperText>{touched?.applyTo && errors && errors.applyTo}</FormHelperText>
      </Grid>
      {console.log(values,"values")}
      <Grid item xs={4} sm={4} className={`form-group`}>
        <FormControl margin="dense" variant="outlined" fullWidth>
          <GuiAutoComplete
            classes={{
              option: classes.option,
            }}
            name={'window'}
            id={'window'}
            size="small"
            value={values?.window ? values?.window : ''}
            getOptionLabel={(option) => {
              return option && option?.repositoryName ? option?.repositoryName : '';
            }}
            onChange={(e, value) => {
              setFieldValue('window', value);
              setFieldValue('field', '');
              setFieldValue('fieldValue', '');
              updateWindowRef.current = true;
              value?.repositoryName ?
                dispatch(fetchUserDefinedFields(value?.repositoryName)) :
                null;
            }}
            options={userDefinedWindowData}
            renderInput={(params) => (
              <div className="select-field">
                <GuiTextField
                  {...params}
                  variant="outlined"
                  // InputLabelProps={{ shrink: true }}
                  label={'Repository Name'}
                  onBlur={handleBlur}
                  required
                  error={Boolean(touched?.window && errors?.window)}
                  placeholder={`Select Repository Name`}
                  className={` ${classes.labelName}`}
                />
              </div>
            )}
          />
        </FormControl>
        <FormHelperText>{touched?.window && errors && errors.window}</FormHelperText>
      </Grid>
      <Grid item xs={4} sm={4} className={`form-group col-sm-3 `}>
        <FormControl margin="dense" variant="outlined" fullWidth>
          <GuiAutoComplete
            classes={{
              option: classes.option,
            }}
            name={'field'}
            id={'field'}
            size="small"
            value={values?.field ? values?.field : ''}
            onChange={(e, value) => {
              setFieldValue('numberOfDays', '');
              setFieldValue('dateStamp', '');
              setFieldValue('ruleGroup', '');
              setFieldValue('field', value);
              setFieldValue('fieldValue', '');
            }}
            options={userDefinedFieldsData}
            getOptionLabel={(option) => {
              return option && option?.fieldName ? option.fieldName : '';
            }}
            onBlur={handleBlur}
            renderInput={(params) => (
              <div className="select-field">
                <GuiTextField
                  {...params}
                  variant="outlined"
                  onBlur={handleBlur}
                  required
                  error={Boolean(touched?.field && errors?.field)}
                  // InputLabelProps={{ shrink: true }}
                  label={'Field Name'}
                  placeholder={`Select Field Name`}
                  className={` ${classes.labelName}`}
                />
              </div>
            )}
          />
        </FormControl>
        <FormHelperText>{touched?.field && errors && errors.field}</FormHelperText>
      </Grid>
      {values?.field?.fieldType != 'Date' && (
        <>
          <Grid item xs={4} sm={4} className={`form-group`}>
            <FormControl margin="dense" variant="outlined" fullWidth>
              <TextField
                margin="dense"
                variant="outlined"
                className={` ${classes.labelName}`}
                placeholder={`Enter Your Value`}
                label={'Value'}
                InputLabelProps={{
                  shrink: true,
                }}
                name={'value'}
                value={values.fieldValue}
                onChange={(e) => {
                  updateWindowRef.current = true;
                  setFieldValue('fieldValue', e.target.value);
                }}
                fullWidth
                onBlur={handleBlur}
              />
            </FormControl>
          </Grid>
        </>
      )}
      {values?.field?.fieldType === 'Date' ? (
        <>
          <Grid item xs={4} sm={4} className={`form-group`}>
            <TextField
              margin="dense"
              variant="outlined"
              // className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder={`Enter Number of Days`}
              label={'Number of Days'}
              // InputLabelProps={{
              //   shrink: true,
              // }}
              InputProps={{
                startAdornment: <InputAdornment position="start">Today +</InputAdornment>,
                inputComponent: NumberFormatterPostiveNegavtive,
              }}
              name={'numberOfDays'}
              value={values?.numberOfDays}
              onChange={(e) => {
                setFieldValue('fieldValue', '');
                setFieldValue('numberOfDays', e.target.value);
              }}
              fullWidth
              onBlur={handleBlur}
              touched={touched.numberOfDays}
              error={touched?.numberOfDays && errors.numberOfDays && errors.numberOfDays}
            />
          </Grid>
          <Grid item xs={4} className={`form-group dateStamp`}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                // className={`${classes.datePicker} ${classes.labelName}`}
                name={'dateStamp'}
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                label={'Date Stamp'}
                fullWidth
                value={values?.dateStamp || null}
                inputVariant="outlined"
                margin="dense"
                onChange={(date) => {
                  setFieldValue('fieldValue', '');
                  setFieldValue('dateStamp', date);
                }}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            className={`${
              values?.field?.fieldType ? 'form-group wait-date-disable-field' : 'form-group'
            }`}
          >
            <TextField
              margin="dense"
              variant="outlined"
              placeholder={`Enter Data Calculation`}
              // className={` ${classes.labelName} ${classes.inputLabel}`}
              label={'Data Calculation'}
              className={`label-overflow ${classes.labelName}`}
              disabled
              // InputLabelProps={{
              //   shrink: true,
              // }}
              name={'ruleGroup'}
              value={values?.ruleGroup?.dataCalculation ? values?.ruleGroup?.dataCalculation : values?.ruleGroup ? values?.ruleGroup : ''}
              onChange={(e) => {
                setFieldValue('fieldValue', '');
                setFieldValue('ruleGroup', e.target.value);
                updateWindowRef.current = true;
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search
                      className={` ${classes.iconSearch}`}
                      onClick={() => {
                        if (values?.field?.fieldType) {
                          dispatch(
                            handleSearchRuleGroupFieldData({
                              status: true,
                              fieldName: 'ruleGroup',
                              setFieldValue: setFieldValue,
                              setShowSearch: setShowSearch,
                              returnType: values?.field?.fieldType,
                            }),
                          );
                          setShowSearch(true);
                        }
                      }}
                      size="sm"
                    />
                    <Clear
                      className={` ${classes.iconSearch}`}
                      onClick={(e) => setFieldValue('ruleGroup', '')}
                    />
                  </InputAdornment>
                ),
              }}
              fullWidth
              onBlur={handleBlur}
              touched={touched.ruleGroup}
              error={touched?.ruleGroup && errors.ruleGroup && errors.ruleGroup}
            />
          </Grid>
        </>
      ) : (
        <Grid
          item
          xs={4}
          sm={4}
          className={`${
            values?.field?.fieldType ? 'form-group wait-date-disable-field' : 'form-group'
          }`}
        >
          <TextField
            margin="dense"
            variant="outlined"
            placeholder={`Enter Data Calculation`}
            // className={` ${classes.labelName} ${classes.inputLabel}`}
            label={'Data Calculation'}
            className={`label-overflow ${classes.labelName}`}
            disabled
            // InputLabelProps={{
            //   shrink: true,
            // }}
            name={'ruleGroup'}
            value={values?.ruleGroup?.dataCalculation ? values?.ruleGroup?.dataCalculation : values?.ruleGroup ? values?.ruleGroup : ''}
            onChange={(e) => {
              setFieldValue('ruleGroup', e.target.value);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search
                    className={` ${classes.iconSearch}`}
                    onClick={() => {
                      if (values?.field?.fieldType) {
                        dispatch(
                          handleSearchRuleGroupFieldData({
                            status: true,
                            fieldName: 'ruleGroup',
                            setFieldValue: setFieldValue,
                            setShowSearch: setShowSearch,
                            returnType: values?.field?.fieldType,
                          }),
                        );
                        setShowSearch(true);
                      }
                    }}
                    size="sm"
                  />
                  <Clear
                    className={` ${classes.iconSearch}`}
                    onClick={(e) => setFieldValue('ruleGroup', '')}
                  />
                </InputAdornment>
              ),
            }}
            fullWidth
            // required
            onBlur={handleBlur}
            error={Boolean(touched?.ruleGroup && errors?.ruleGroup)}
          />
          <FormHelperText>{touched?.ruleGroup && errors && errors.ruleGroup}</FormHelperText>
        </Grid>
      )}
    </>
  );
};

export default UpdateUserDefined;
